<template>
  <div id="app">
    <router-view />
    <BaseToast />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* App-specific styles only - all global styles are in main.css */
#app {
  width: 100%;
  min-height: 100vh;
}
</style>